import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] =
    useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] =
    useState(false);

  const submit = async event => {
    event.preventDefault();
    setError('');
    setSending(true);

    try {
      await post(
        '/auth/forgot-password',
        { email }
      );

      setSubmitted(true);
    } catch (requestError) {
      setError(
        requestError.message ||
          'The request could not be submitted. Please try again.'
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>BloansBooks</h1>
          <p>Bloans Creations Ltd</p>
        </div>

        {submitted ? (
          <>
            <div
              className="alert"
              style={{
                background: '#E8F5EB',
                border: '1px solid #B8D8BE',
                color: '#2E6B3A',
                marginBottom: 20
              }}
            >
              If an active account exists for that
              email address, a password-reset link
              has been sent.
            </div>

            <p
              className="text-muted text-sm"
              style={{
                lineHeight: 1.6,
                marginBottom: 20
              }}
            >
              Check your inbox and spam folder. The
              link expires after 30 minutes and can
              be used only once.
            </p>

            <Link
              to="/login"
              className="btn btn-primary"
              style={{
                width: '100%',
                justifyContent: 'center'
              }}
            >
              Return to Sign In
            </Link>
          </>
        ) : (
          <>
            <h2
              style={{
                fontSize: 20,
                color: 'var(--ink)',
                marginBottom: 8
              }}
            >
              Forgot your password?
            </h2>

            <p
              className="text-muted text-sm"
              style={{
                lineHeight: 1.6,
                marginBottom: 20
              }}
            >
              Enter the email address connected to
              your BloansBooks account. We will send
              you a secure password-reset link.
            </p>

            {error && (
              <div
                className="alert alert-error"
                style={{ marginBottom: 20 }}
              >
                {error}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="form-group">
                <label className="form-label">
                  Email address
                </label>

                <input
                  type="email"
                  className="form-control"
                  placeholder="you@bloanshandbags.com"
                  value={email}
                  onChange={event =>
                    setEmail(event.target.value)
                  }
                  autoComplete="email"
                  required
                  autoFocus
                  disabled={sending}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  marginTop: 8
                }}
                disabled={sending}
              >
                {sending
                  ? 'Sending...'
                  : 'Send Reset Link'}
              </button>
            </form>

            <p
              className="text-muted text-sm"
              style={{
                textAlign: 'center',
                marginTop: 20
              }}
            >
              <Link
                to="/login"
                style={{
                  color: 'var(--forest)',
                  fontWeight: 600
                }}
              >
                Return to Sign In
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
